import React, { useContext, useMemo } from 'react';
import { ChildrenPropType } from '../../../../../prop-types/children';
import useSellerLabelProviderBalanceMap from '../hooks/use-seller-label-provider-balance-map';

const SellerLabelProviderDataContext = React.createContext();
export const useSellerLabelProviderDataContext = () => useContext(SellerLabelProviderDataContext);

const SellerLabelProviderDataContextProvider = ({ children }) => {
  const { balancesMap, loading: loadingBalancesMap } = useSellerLabelProviderBalanceMap();

  const value = useMemo(
    () => ({
      balancesMap,
      loadingBalancesMap,
    }),
    [balancesMap, loadingBalancesMap],
  );

  return <SellerLabelProviderDataContext.Provider value={value}>{children}</SellerLabelProviderDataContext.Provider>;
};

SellerLabelProviderDataContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default SellerLabelProviderDataContextProvider;

export const useSellerLabelProviderBalance = (sellerLabelProviderId) => {
  const { balancesMap, loadingBalancesMap } = useSellerLabelProviderDataContext();
  return {
    loadingBalancesMap,
    balance: balancesMap?.[sellerLabelProviderId]?.balance,
  };
};
